import(/* webpackMode: "eager", webpackExports: ["LoginLeftPanel"] */ "/app/src/app/login/components/login-left-panel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LoginRightPanel"] */ "/app/src/app/login/components/login-right-panel.tsx");
